import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../services/auth.service';

import { GrupoProdutoService } from '../services/grupo-produto.service';
import Swal from 'sweetalert2';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';



@Component({
	selector: 'app-grupos-produto',
	templateUrl: './grupos-produto.component.html',
	styleUrls: ['./grupos-produto.component.css'],
	animations: [loadingFade, modal, alert]
})
export class GruposProdutoComponent implements OnInit {


	public menu_id = 158;

	public loading = false;
	public gruposProduto;

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

		//acesso
		public usuario_perfil;
		public visualizar = true;
		public editar = false;	

	constructor(private grupoProdutoSvc: GrupoProdutoService,
		private router: Router,	
		private route: ActivatedRoute,
		private perfilUsuarioSvc: PerfilUsuarioService,
		private authSvc: AuthService) { }

	ngOnInit() {

		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		}); 	

		this.pegaGruposProduto();
	}

	pegaGruposProduto(){
		this.loading = true;
		this.grupoProdutoSvc.getGruposProdutoCadastro().then((data: any) => {
			this.gruposProduto = data;
			this.count = this.gruposProduto.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		});
	}


	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	apagaGrupoProduto(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.grupoProdutoSvc.apagaGrupoProduto(id).then((data) => {
					this.pegaGruposProduto();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}
}
